import App from '../main';
import BaseGamePlay from './basegameplay';

export default class RushMode extends BaseGamePlay {
    protected platformAmount: number = 12;
    protected platformStep: number = 0.75 * 200;

    constructor() {
        super('RushMode', App.RUSH_MODE_DROP_SPEED);
    }

    init() {
        this.score = this.registry.get('score');
        this.highScore = this.registry.get('highScore');
        App.stars = this.registry.get('stars');
    }

    create() {
        this.cameras.main.fadeIn(250, 255, 255, 255);
        this.isRushMode = true;
        super.create();
        if (this.events.listenerCount('wake') <= 0) {
            this.events.on('wake',  () => {
                this.inputEnabled = true;
                this.scene.restart();
            }, this);
        }

        this.time.addEvent({
            delay: App.RUSH_MODE_TIME,
            callback:() => {
                this.registry.set('score', this.score);
                this.registry.set('highScore', this.highScore);
                this.registry.set('stars', this.stars);
                this.cameras.main.fadeOut(250, 255, 255, 255);
            },
            callbackScope: this
        })
    }

    spawnCollectibles(platform) {
        this.currentCollectibles = 'star';
        this.currentStar = 'rainbow';
        this.setCollectibles(platform);
    }

    initPlatforms() {
        super.initPlatforms();
        this.platforms.children.iterate( (platform: any) => {
            if (platform == this.platforms.getChildren()[0]) {
                platform.isFirstPlatform = true;
                platform.collectible.disableBody(true, true);
            }
            else {
                platform.isFirstPlatform = false;
            }
            platform.setTexture('Platforms_1', 'Platforms_1_0');
            platform.fill.setTintFill(0xE7E7E7);
            platform.top.setTexture('Platforms_1', 'Platforms_1_1').setTintFill();
            platform.pattern.setTexture('Platforms_3', 'Platforms_3_1').setAlpha(1);

            var displayHeight = platform.displayHeight;
            platform.setDisplaySize(this.width, displayHeight);
            platform.scaleY = 0.75 * 0.5;
            platform.fill.setScale(platform.scaleX, platform.scaleY);
            platform.top.setScale(platform.scaleX, platform.scaleY);
            platform.pattern.setScale(platform.scaleX, platform.scaleY);

            platform.collectible.x = platform.x;
            platform.collectible.y = platform.y - ((platform.displayHeight / 2) + 30);
        }, this)
    }
}